import React from 'react';

import { useTranslation } from 'react-i18next';

import { styled } from '@mui/material/styles';
import GetAppIcon from '@mui/icons-material/GetApp';

import { capitalize } from 'helpers/helpers';
import TooltipIconButton from 'components/TooltipIconButton';

import Alert from 'ui/Alert/Alert';

type Props = {
    download(): void;
};

const StyDownloadDataAlert = styled(Alert, {
    name: 'StyDownloadDataAlert',
})({
    alignItems: 'center',
    marginTop: '2rem',
    marginBottom: '1rem',
    backgroundColor: 'white',
    boxShadow: '4px 4px 24px rgba(0, 0, 0, 0.12)',
});

const DownloadDataAlert = ({ download }: Props): React.ReactElement => {
    const { t } = useTranslation();

    return (
        <StyDownloadDataAlert
            severity="warning"
            action={
                <TooltipIconButton
                    tooltip={capitalize(t('common.download'))}
                    placement="bottom"
                    onClick={download}
                    icon={<GetAppIcon />}
                />
            }
        >
            {t('importCSV.downloadPreviousData')}
        </StyDownloadDataAlert>
    );
};

export default DownloadDataAlert;
